import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useContext } from 'react';
import AppContext from '../AppContext';
import { AssignSitesToOrganizationInput, AssignSitesToOrganizationPayload } from './generated/types';


const mutation = `mutation AssignSitesToOrganization($input: AssignSitesToOrganizationInput!) {
    assignSitesToOrganization(input: $input) {
        parentOrgId
        siteOrgIds
    }
}`;

export const useAssignSitesToOrg = (parentOrgId: string) => {
    const context = useContext(AppContext);
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (siteOrgIds: Array<string>) => {

            const input: AssignSitesToOrganizationInput = {
                parentOrgId,
                siteOrgIds,
            };

            const { data } = await (context.api.graphql({
                query: mutation,
                variables: { input },
            }) as Promise<{
                data: {
                    assignSitesToOrganization: AssignSitesToOrganizationPayload;
                };
            }>);

            return data.assignSitesToOrganization;
        },
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: ['listOrganizations'] });
        },
    });
};
